/**
 * Styled Components - Created by david on 08/06/18.
 */
import styled from 'styled-components'
import {
  WHITE,
  GRAY_DARK,
  RED,
  BLUE,
  GREEN_BRIGHT,
  ORANGE_STATUS
} from '../../../theme/colors'
import { AVENIR_NEXT } from '../../../theme/fonts'
import Icon from 'antd/lib/icon'

export const Container = styled.div`
  height: 100%;
  overflow-y: scroll;
  scroll-behavior: smooth;
  @media (min-height: 800px) and (orientation: portrait) {
    height: 85vh;
  }

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
    height: 70vh;
  }

  @media only screen and (min-device-width: 1366px) and (max-device-width: 1366px) and (orientation: landscape) {
    height: 78vh;
  }
`

export const DraggerContainer = styled.div`
  height: 50vh;
  padding: 8px;
`

export const DraggerBottom = styled.div`
  padding: 8px;
  position: relative;
  .ant-upload {
    width: 100%;
  }
  .ant-upload.ant-upload-drag {
    background: #E8E5E5;
    padding: 8px 0;
    border: 1px dashed #302628;
    width: auto !important;
    margin-inline: 10px;
    img {
      filter: brightness(0.5);s
    }
  }
  .ant-upload-drag-container > div > div {
    color: #302628;
  }
`

export const StyledAlertMessage = styled.div`
  display: flex;
  position: absolute;
  right: 12px;
  z-index: 2;
  top: -20px;
  text-align: right;
  max-width: 382px;
  background: black;
  border-radius: 3px;
  padding: 2px 6px;
  color: white;
  display: none;
  animation: fade-in-right-alert 0.25s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-right-alert {
    0% {
    transform: translateX(10px);
      opacity: 0;
    }
    100% {
    transform: translateX(0);
      opacity: 1;
    }
  }
`

export const AlertIcon = styled(Icon)`
  color: red;
  padding-top: 3px;
`

export const LoginMessage = styled.div`
  font-size: 16px;
  line-height: 23px;
  margin-top: 16px;
  text-align: center;
`

export const Text = styled.div`
  color: ${WHITE};
`

export const Header = styled.div`
  padding: 6px 30px;
  display: flex;
  flex-direction: column;
  row-gap: 6px;
  justify-content: space-between;
  min-height: 55px;
  align-items: center;
`

type Props = {
  color?: string
}

export const Recommendation = styled.div`
  color: ${({ color = GRAY_DARK }: Props) => color};
  font-size: 14px;
  letter-spacing: 0px;
  line-height: 23px;
  padding: 8px 20px;

  @media (min-width: 768px) and (max-width: 991px) {
    padding: 8px 10px;
  }
`

export const EmptyContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  height: 60vh;
  justify-content: center;
`

export const LockContainer = styled.div`
  cursor: pointer;
  padding: 2px;
  display: inline-block;
  font-size: 20px;
`

export const RefreshIcon = styled(Icon)`
  margin-right: 12px;
`

export const RefreshButton = styled.div`
  display: flex;
  align-items: center;
  transition: all .25s;
  width: 194px;
  height: 31px;
  border: 1px solid #C91731;
  color: #C91731;
  justify-content: center;
  border-radius: 25px;
  align-self: flex-end;
  font-weight: 500;
  font-family: Avenir;
  .ant-spin {
    transform: scale(0.75);
    margin-top: 0px;
    margin-right: 6px;
    margin-bottom: -4px;
  }
  &:hover {
    cursor: pointer;
    background: #C91731;
    color: ${WHITE};
  }
`

export const CustomButton = styled.div`
  padding: 5px;
  border: 1px solid ${GRAY_DARK};
  border-radius: 4px;
  justify-content: center;
  width: 200px;
  margin-top: 22px;
  display: inline-flex;
  cursor: pointer;
  transition: background 0.4s ease, color 0.3s ease;
  &:hover {
    background: ${GRAY_DARK}
    color: ${WHITE}
  }
`

export const ArrowIcon = styled.img`
  padding-right: 8px;
  cursor: pointer;
`

export const LowerContainer = styled.div`
  display: flex;
  flex-flow: column;
  height: calc(100vh - 236px);
  #filesListSection {
    max-height: unset;
    min-height: 168px;
  }
`

export const ModalTitle = styled.div`
  color: ${GRAY_DARK};
  font-family: ${AVENIR_NEXT};
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const InfoBody = styled.div`
  color: ${GRAY_DARK};
  font-family: ${AVENIR_NEXT};
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: -38px;
`

export const SizeTitle = styled.div`
  color: ${RED};
  text-align: center;
  font-weight: bold;
`

export const SizeBody = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin-top: 24px;
  margin-bottom: 12px;
  margin-left: -38px;
  span {
    color: ${GREEN_BRIGHT};
    font-weight: bold;
  }
`

export const DPIWarning = styled.div`
  margin-top: 24px;
  color: ${ORANGE_STATUS};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const WarningDPI = styled(Icon)`
  margin-right: 12px;
  color: ${ORANGE_STATUS};
`

export const DPIText = styled.div``

export const WarningIcon = styled(Icon)``

export const buttonStyle = {
  background: BLUE,
  border: 'none',
}

export const PreviewRight = styled.div`
  margin: -12px -6px 16px -42px;
`

export const ImageContent = styled.div`
  width: 100%;
  text-align: center;
`

export const ImagePreview = styled.img`
  max-width: 100%;
  max-height: 179px;
  margin: 0 auto;
  display: inline-block;
  margin-bottom: 14px;
  border-radius: 3px;
  margin-top: -12px;
`

export const LogoImage = styled.img`
  width: 100%;
  height: 220px;
  object-fit: contain;
  font-size: 24px;
  color: ${GRAY_DARK};
  background: #F1F4F5;
  margin: 0 auto;
  padding: 64px;
`

export const PDFPreview = styled.embed`
  margin-bottom: 14px;
  box-shadow: 1px 1px 4px 1px lightgrey;
`

export const TermsLabel = styled.div``

export const EditContent = styled.div`
  color: ${RED};
  margin-bottom: 4px;
`

export const TermsLink = styled.div`
  color: ${BLUE};
  margin-left: 4px;
  margin-right: 4px;
  display: inline-flex;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`

export const TitleTerms = styled.div`
  font-weight: bold;
  margin-top: 22px;
  font-size: 16px;
  text-align: center;
`

export const TooltipContentModal = styled.div`
  margin-left: -22px;
  width: 100%;
`

export const ErrorContent = styled.div`
  margin-left: -36px;
  width: calc(100% + 36px);
`

export const TooltipBody = styled.div`
  padding-top: 16px;
  padding-left: 8px;
  padding-right: 10px;
  margin-bottom: 12px;
  max-height: 448px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, .5);
    box-shadow: 0 0 1px rgba(255, 255, 255, .3);
  }
  .highlight {
    color: red;
    font-style: italic;
  }

  b {
    font-weight: 700;
  }
  @media (max-width: 767px) {
    padding-top: 30px;
    padding-left: 19px;
    padding-right: 17px;
  }
`

export const ErrorBody = styled.div`
  ul {
    padding-left: 16px;
    margin-top: -6px;
  }
`

export const ErrorTitle = styled.div`
  font-size: 24px;
  font-weight: bold;
  font-family: Avenir;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
`

export const ErrorFileName = styled.div`
  margin-bottom: 12px;
  color: #e34b62;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const BrokenImage = styled.img`
  max-width: 22px;
  margin-right: 8px;
`

export const errorButtonStyle = {
  color: '#3979c3',
  background: WHITE,
  borderColor: '#4A90E2',
  textShadow: 'none'
}

export const closeButtonStyle = {
  position: 'absolute',
  right: '-6px',
  top: '-6px',
  color: '#393939',
  border: '1px solid #2d2d2d',
  borderRadius: '25px',
  width: '24px',
  height: '24px',
  background: 'white',
  fontSize: '12px',
  padding: '0',
  lineHeight: 'unset'
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/UploadTab/styledComponents.tsx